import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useCheckoutBillingStore = create(
  persist(
    (set) => ({
      countryCodeBilling: null,
      productId: null,
      paypalProductId: null,
      setProductId: (productId) => set({ productId }),
      setPaypalProductId: (paypalProductId) => set({ paypalProductId }),
      setCountryCodeBilling: (countryCodeBilling) => set({ countryCodeBilling }),
    }),
    {
      name: 'billing-store',
      partialize: (state) => ({
        productId: state.productId,
      }),
    },
  ),
);
